import React from 'react';
import { Image, Typography } from 'lib/components';
import { Color, ImageSource } from 'lib/components/types';
import classes from './index.module.scss';

/**
 * Props interface for the ActionButton component
 */
interface Props {
	/** Optional icon to display on the left side of the button */
	leftIconSrc?: ImageSource;
	/** Click handler function */
	onClick?: () => any;
	/** Text to display in the button */
	title: string;
	/** Optional icon to display on the right side of the button */
	rightIconSrc?: ImageSource;
	/** Color theme for the button (primary, success, danger, etc.) */
	status?: Color;
}

/**
 * ActionButton component
 * Renders a styled button with optional icons and configurable color theme
 * Used for invoice actions like void, unvoid, etc.
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} - Rendered component
 */
const ActionButton = ({ leftIconSrc, title, rightIconSrc, status = 'primary', onClick }: Props) => {
	// Combine base class with status-specific class (e.g., actionButton-primary)
	const className = classes['actionButton'] + ' ' + classes['actionButton-' + status];

	return (
		<a onClick={onClick} className={className}>
			{/* Left icon (if provided) */}
			{leftIconSrc && <Image className={classes['actionButton-left']} src={leftIconSrc} />}
			{/* Button text with status color */}
			<Typography className={classes['actionButton-title']} color={status}>
				{title}
			</Typography>
			{/* Right icon (if provided) */}
			{rightIconSrc && <Image className={classes['actionButton-right']} src={rightIconSrc} />}
		</a>
	);
};

export default ActionButton;
